export function getOrdinal(n: number): string {
  // From https://community.shopify.com/c/Shopify-Design/Ordinal-Number-in-javascript-1st-2nd-3rd-4th/m-p/72156
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

/**
 * Function to format the out of stock date.
 *
 * @param date string eg: `22 June`
 * @param format string eg: `mobile | short | long | regular`
 *
 * @returns mobile: 22nd Jun, short: 22nd June, regular: 29 June, long: Monday 22nd June 2021
 */
export function formatOOSDate(
  date: string,
  format: "long" | "short" | "mobile" | "regular" = "short"
): string {
  const dateObj = new Date(date);
  let day = "";
  let dayName = "";
  let month = "";
  let year = "";

  dayName =
    format === "long"
      ? `${dateObj.toLocaleDateString("en-GB", {
          weekday: "long"
        })} `
      : "";

  day = parseInt(
    dateObj.toLocaleDateString("en-GB", {
      day: "numeric"
    }),
    10
  ).toString();

  if (format !== "regular") {
    day = getOrdinal(
      parseInt(
        dateObj.toLocaleDateString("en-GB", {
          day: "numeric"
        }),
        10
      )
    );
  }

  month = dateObj.toLocaleDateString("en-GB", {
    month: format === "mobile" ? "short" : "long"
  });

  year =
    format === "long"
      ? ` ${dateObj.toLocaleDateString("en-GB", {
          year: "numeric"
        })}`
      : "";

  return `${dayName}${day} ${month}${year}`;
}
